"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

function createCRUDReducer(actionTypes, keyOfId) {
  return function getNewState(state, origianalAction) {
    var _a, _b;

    if (state === void 0) {
      state = {};
    }

    if (origianalAction.type === actionTypes.updateOne) {
      var action = origianalAction;

      if (state[action.info[keyOfId]]) {
        return __assign(__assign({}, state), (_a = {}, _a[action.info[keyOfId]] = __assign(__assign(__assign({}, state[action.info[keyOfId]]), action.extra), {
          info: __assign(__assign({}, state[action.info[keyOfId]].info), action.info)
        }), _a));
      }
    } else if (origianalAction.type === actionTypes.updateMany) {
      var action_1 = origianalAction;

      var newState1_1 = __assign({}, state);

      action_1.infos.forEach(function (c, i) {
        if (!newState1_1[c[keyOfId]]) return;
        newState1_1[c[keyOfId]] = __assign(__assign(__assign({}, newState1_1[c[keyOfId]]), action_1.extras && action_1.extras[i]), {
          info: __assign(__assign({}, newState1_1[c[keyOfId]].info), c)
        });
      });
      return newState1_1;
    } else if (origianalAction.type === actionTypes.loadOne) {
      var action = origianalAction;
      return __assign(__assign({}, state), (_b = {}, _b[action.info[keyOfId]] = __assign(__assign(__assign(__assign({}, state[action.info[keyOfId]]), {
        loadTime: new Date(action.loadTime)
      }), action.extra), {
        info: action.info
      }), _b));
    } else if (origianalAction.type === actionTypes.loadMany) {
      var action_2 = origianalAction;
      var newState1_2 = action_2.clearOthers === "replaceAll" ? {} : __assign({}, state);

      if (Array.isArray(action_2.clearOthers)) {
        for (var _i = 0, _c = action_2.clearOthers; _i < _c.length; _i++) {
          var id = _c[_i];
          delete newState1_2[id];
        }
      }

      action_2.infos.forEach(function (c, i) {
        newState1_2[c[keyOfId]] = __assign(__assign({
          loadTime: new Date(action_2.loadTime)
        }, action_2.extras && action_2.extras[i]), {
          info: c
        });
      });
      return newState1_2;
    } else if (origianalAction.type === actionTypes.deleteOne) {
      var action = origianalAction;

      var newState = __assign({}, state);

      delete newState[action[keyOfId]];
      return newState;
    } else if (origianalAction.type === actionTypes.deleteMany) {
      var action = origianalAction;

      var newState = __assign({}, state);

      for (var _d = 0, _e = action.ids; _d < _e.length; _d++) {
        var id = _e[_d];
        delete newState[id];
      }

      return newState;
    } else if (origianalAction.type === actionTypes.clearAll) {
      return {};
    }

    return state;
  };
}

exports.default = createCRUDReducer;